import { distanceM, localFrame, toLocal } from '../geo/distance.js';
export function progressAlongRoute(route, position) {
    if (route.shape.length < 2 || route.maneuvers.length === 0) {
        return null;
    }
    const gelotet = lote(route.shape, position);
    /*
     * Der Hinweis, in dessen Abschnitt der Fahrer steht — und damit der nächste.
     * Manöver tragen die Stelle in der Geometrie, an der sie beginnen; gesucht ist
     * das letzte, das nicht hinter dem Fahrzeug liegt.
     */
    let laufend = 0;
    for (let i = 0; i < route.maneuvers.length; i += 1) {
        if (route.maneuvers[i].shapeIndex <= gelotet.index) {
            laufend = i;
        }
        else {
            break;
        }
    }
    /*
     * Ein Wendehinweis am Anfang ist nicht vorbei, sondern fällig.
     *
     * Sonst gilt: Das Manöver, in dessen Abschnitt der Fahrer steht, hat er
     * gerade — gezeigt wird das nächste. Für „Bitte wenden" ist das falsch. Der
     * Hinweis steht in Manöver 0 (siehe A-70), und Manöver 0 ist genau das, was
     * hier übersprungen wird. Auf der Ausfahrt „Henglarn" am 28.08.2026 fuhr ein
     * Fahrer deshalb zweimal abseits, ohne je zum Umkehren aufgefordert zu
     * werden: Der Routingdienst schickte ihn mit 180 Grad Unterschied zurück, der
     * Server schrieb ordnungsgemäß „Bitte wenden" — und der Balken zeigte
     * stattdessen die übernächste Abbiegung.
     *
     * Es löst sich von selbst auf: Sobald er gewendet hat, stimmt sein Kurs mit
     * dem Anfang der Route überein, aus dem Manöver wird wieder ein gewöhnliches
     * „Losfahren", und der Balken zeigt wie sonst das nächste.
     */
    const wendenFällig = laufend === 0 && route.maneuvers[0]?.kind === 'uturn';
    const nächster = wendenFällig ? 0 : Math.min(laufend + 1, route.maneuvers.length - 1);
    const bisNächstem = nächster === laufend
        ? 0
        : streckeBis(route.shape, gelotet, route.maneuvers[nächster]?.shapeIndex ?? 0);
    let restM = bisNächstem;
    let restMs = 0;
    for (let i = nächster; i < route.maneuvers.length; i += 1) {
        const m = route.maneuvers[i];
        if (m === undefined) {
            continue;
        }
        restM += m.lengthM;
        restMs += m.travelMs;
    }
    // Die Fahrzeit des laufenden Abschnitts anteilig: Wer die halbe Strecke bis
    // zum nächsten Abbiegen hinter sich hat, hat auch die halbe Zeit hinter sich.
    const laufendes = route.maneuvers[laufend];
    if (laufendes !== undefined && laufendes.lengthM > 0 && nächster !== laufend) {
        restMs += laufendes.travelMs * Math.min(1, bisNächstem / laufendes.lengthM);
    }
    return {
        maneuverIndex: nächster,
        distanceToManeuverM: bisNächstem,
        remainingM: restM,
        remainingMs: Math.round(restMs),
        offRouteM: gelotet.offM,
        onTrack: gelotet.index >= route.rejoinShapeIndex,
    };
}
/** Lotet die Position auf die Route und liefert die nächstgelegene Stelle. */
function lote(shape, position) {
    const frame = localFrame(position);
    const p = toLocal(frame, position);
    let beste = { index: 0, t: 0, offM: Number.POSITIVE_INFINITY };
    for (let i = 0; i < shape.length - 1; i += 1) {
        const a = toLocal(frame, shape[i]);
        const b = toLocal(frame, shape[i + 1]);
        const vx = b.x - a.x;
        const vy = b.y - a.y;
        const länge = vx * vx + vy * vy;
        const t = länge === 0 ? 0 : Math.min(1, Math.max(0, ((p.x - a.x) * vx + (p.y - a.y) * vy) / länge));
        const offM = Math.hypot(p.x - (a.x + t * vx), p.y - (a.y + t * vy));
        if (offM < beste.offM) {
            beste = { index: i, t, offM };
        }
    }
    return beste;
}
/** Strecke von der geloteten Stelle bis zu einem Punkt der Geometrie. */
function streckeBis(shape, von, bisIndex) {
    const a = shape[von.index];
    const b = shape[von.index + 1];
    const aufDemAbschnitt = {
        lat: a.lat + (b.lat - a.lat) * von.t,
        lon: a.lon + (b.lon - a.lon) * von.t,
    };
    if (bisIndex <= von.index) {
        return 0;
    }
    let strecke = distanceM(aufDemAbschnitt, shape[von.index + 1]);
    for (let i = von.index + 1; i < bisIndex; i += 1) {
        strecke += distanceM(shape[i], shape[i + 1]);
    }
    return strecke;
}
//# sourceMappingURL=progress.js.map